import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { IdentificateComponent } from './core/identificate/identificate.component';
import { NavComponent } from './core/nav/nav.component';
import { MenuComponent } from './core/menu/menu.component';
import { RecuperacionComponent } from './core/recuperacion/recuperacion.component';
import { AuthGuard } from './core/guards/auth.guards';
import { NoEncontradoComponent } from './shared/components/no-encontrado/no-encontrado.component';
import { AppComponent } from './app.component';

const routes: Routes = [
    {
    path: "menu",
    component: MenuComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'perfil', loadChildren: () => import('./modules/perfil/perfil.module').then(m => m.PerfilModule) },
      { path: 'resultados', loadChildren: () => import('./modules/resultados/resultados.module').then(m => m.ResultadosModule) },
      { path: '', component: AppComponent },
      { path: 'no-encontrado', component: NoEncontradoComponent },
      { path: '**', redirectTo: 'no-encontrado' },
      ]
    },
    {
      path: "", component: NavComponent, children: [
        { path: '', component: IdentificateComponent },
        { path: "identificate", component: IdentificateComponent },
        { path: "recuperacion", component: RecuperacionComponent },
        { path: 'no-encontrado', component: NoEncontradoComponent },
        { path: '**', redirectTo: 'no-encontrado' },
      ]
    }
  ];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
